module.exports = __webpack_public_path__ + "static/media/18ECA41.86fd68d3.jpg";